import { Typography } from '@neo4j-ndl/react';
import type { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren & {
  title: ReactNode;
};

export const BaseInstanceCreateSection = ({ title, children }: Props) => {
  return (
    <div className="border-neutral-border-weak bg-neutral-bg-weak @container flex flex-col gap-4 rounded-lg border p-8">
      <Typography variant="h6">{title}</Typography>
      {children}
    </div>
  );
};

export const BaseSectionItemsWrapper = ({ children }: PropsWithChildren) => {
  return (
    <div className="bg-neutral-bg-on-bg-weak rounded-1xl flex flex-col items-center justify-between gap-6 p-4">
      {children}
    </div>
  );
};
